import { UserRound } from 'lucide-react'

interface AvatarProps {
  src?: string | null
  alt?: string
  /** Pixel size of the square avatar. */
  size?: number
  className?: string
}

/** Circular avatar with a person-icon fallback, like the iOS AvatarView. */
export function Avatar({ src, alt = '', size = 40, className = '' }: AvatarProps) {
  return (
    <span
      className={`bg-surface-hover inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full ${className}`}
      style={{ width: size, height: size }}
    >
      {src ? (
        <img src={src} alt={alt} loading="lazy" className="size-full object-cover" />
      ) : (
        <UserRound className="text-fg-subtle" style={{ width: size * 0.55, height: size * 0.55 }} />
      )}
    </span>
  )
}
